import { render, staticRenderFns } from "./UserNameTag.vue?vue&type=template&id=882d9956&scoped=true"
import script from "./UserNameTag.vue?vue&type=script&lang=js"
export * from "./UserNameTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882d9956",
  null
  
)

export default component.exports